



// NOVO 2025-07-12
const temp_nakon_kreiranja_templatea_bez_emaila = {
  "message": "Survey template created successfully.",
  "survey": {
    "survey_template_id": 7,
    "title": "direktni 1",
    "text": "direktni text",
    "img_url": null,
    "date_created_template": "2025-07-13T11:37:22.000Z",
    "service_type": "Prodaja",
    "first_email_title": null,
    "first_email_content": null,
    "second_email_title": null,
    "second_email_content": null,
    "is_review": false,
    "review_text": null,
    "review_link": null,
    "internal_name": "direktni 1int",
    "is_qr": true,
    "templateUrl": "https://dev.ratemyservice.rs/templates?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW1wbGF0ZV9pZCI6NywiY2xpZW50X2lkIjoxLCJpYXQiOjE3NTI0MDY2NDIsImV4cCI6MTc1MjQxMDI0Mn0.ea9VTHeIiLULNfcEckgToO4qOfMtuYiKG3gLurK7tBo",
    "client": {
      "client_id": 1,
      "name": "AK KOMPRESOR NISSAN",
      "email": "jasmina.vojinovic@akkompresor.rs",
      "phone": "+381658148181",
      "logo": null,
      "is_active": true,
      "api_key": "AIzaSyD3lcpyU2ZrQpcix7z0lW2hahvg1jUVfHw",
      "place_id": "ChIJv1uCxxl7WkcRXZDijRN5yf0"
    },
    "questions": [
      {
        "question_id": 11,
        "question_type": "text",
        "title": "Direkt 1",
        "required": false,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": false,
        "extra_answer_required": null,
        "extra_question_title": null,
        "extra_answer_condition": null
      },
      {
        "question_id": 12,
        "question_type": "stars",
        "title": "Direkt 2",
        "required": false,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": false,
        "extra_answer_required": null,
        "extra_question_title": null,
        "extra_answer_condition": null
      }
    ]
  }
};


//
export const consent_1_text_20250506 = `SAGLASNOST ZA OBRADU LIČNIH PODATAKA I KOMUNIKACIJU

Potvrđujem da dajem saglasnost za primanje personalizovanih ponuda u vezi sa kupovinom vozila, postprodajnih proizvoda i usluga, kao i informacija o događajima, pogodnostima i drugim aktuelnostima koje se odnose na vozila i usluge u domenu auto-industrije.

Takođe, dozvoljavam upotrebu sledećih kanala komunikacije u navedene svrhe:
  - E-pošta
  - SMS
  - Telefon
  - Obična pošta

Pored toga, saglasan/saglasna sam da primam pozive za učešće u anketama o zadovoljstvu proizvodima i uslugama.

Saglasan/saglasna sam da se moji lični podaci (ime, prezime, adresa, e-adresa, broj telefona, broj šasije, marka, model, verzija i starost vozila) obrađuju u skladu sa važećim propisima o zaštiti podataka o ličnosti.

Upoznat/a sam sa informacijama o obradi mojih ličnih podataka.`;



/*
{
    "question_id": 4,
    "q": {
        "question_id": 4,
        "question_type": "SCALE_5",
        "title": "Neki scale",
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": false,
        "extra_answer_required": null,
        "extra_question_title": null,
        "extra_answer_condition": null,
        "answer": null
    },
    "answer_main": null,
    "answer_extra": null
}
*/


// DUMMY image_url blob
const _zzsurvey_dummy_other = {
  dummy_survey_logo_img_src: "data:image/png;base64,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",
};


//
export const _zzsurvey_dummy_res_v1 = {
  "success": true, // oznaka za prepoznavanje uspešnog responsea
  "frfr_srf": true, // oznaka za prepoznavanje uspešnog responsea
  "frfr_srf_version": "1", // oznaka za prepoznavanje uspešnog responsea
  "payload": { // payload sadrži traženi sadržaj uspešnog responsea
    meta: {
      // TODO
      survey_key: 123, // Ovo nije ID iz baze. ID surveya je skriven od korisnika, on samo može da vidi šifru/ključ na osnovu koje se kasnije na backendu pronadje id i sve ostalo što treba.
    },
    survey_img_src: null, // ako je null nema slike u headeru ankete. Ako je URL prikazujem sliku u headeru ankete.
    internal_name: '* Demo quiz', // interni zaziv ankete
    title: 'Kratki upitnik o iskustvu nakon kupovine motocikla', // naslov ankete
    survey_text: 'Vaše mišljenje nam je važno! Molimo vas da odgovorite na naša pitanja.', // tekst ispod naslova ankete
    service_type: 'Web design',
    questions: [
      {
        question_id: 1, // id questioan uvek postoji i obavezan je da psotoji prilikom submitovanja.
        question_type: 'TEXT',
        title: 'Pitanje TEXT 1?',
        answer_id: 301, // ako se prazan forma prvi put prikazuje customeru onda je answer_id null.
        answer: "Neki odgovor", // tekstualni odgovor
      },
      {
        question_id: 2,
        question_type: 'YES_NO',
        title: 'Pitanje YES_NO 1?',
        answer_id: 302, // ako se prazan forma prvi put prikazuje customeru onda je answer_id null.
        answer: true, // true (YES) / false (NO)
        required: true, // true znači da customer mora obavezno da odgovori na ovo pitanje inače forma neće biti validna za submit.
        //
        extra_question_title: 'Zašto ste izabrali DA?', // extra_question_title
        // Propertiji za extra answer mogu da se pojavljuju kod svih tipova pitanja izuzev 'TEXT':
        extra_answer_enabled: true, // znači da polje za extra answer može da se pojavi. Ako je false neće se pojaviti nikako.
        extra_answer_required: true, // znači da je extra answer obavezno mora da se popuni ukoliko se polje pojavi
        extra_answer_condition: true, // znači da se extra answer pojavljuje kada se value answera podudara sa condition. Ako ovaj properti postoji ali je null znači da se polje svakako prikazuje nije uslovljeno ničim. null bukvalno znači nema uslova.
        // NAPOMENA: ukoliko je question_type 'CHECKLIST' a condition je "" (prazan string) to znači da se polje pojavljuje ako nije checkirana ni jedna opcija. Do daljnjeg nećemo ništa više komplikovati sa checklistom.
        answer_extra: 'Zašto ste izabrali DA?', // extra answer
      },
      {
        question_id: 3,
        question_type: 'ABC',
        title: 'Pitanje ABC 1?',
        question_option_titles: {
          "A": 'Alfa', // u tabeli questions ovo polja nazvati opt_a
          "B": 'Bravo', // u tabeli questions ovo polja nazvati opt_b
          "C": 'Charlie', // u tabeli questions ovo polja nazvati opt_c
          "D": 'Delta', // itd...
          "E": null, // znači da u ovom slučaju opcija E ne postoji
          "F": null, // znači da u ovom slučaju opcija ne postoji
          "G": null, // znači da u ovom slučaju opcija ne postoji
          "H": null, // znači da u ovom slučaju opcija ne postoji
          "I": null, // znači da u ovom slučaju opcija ne postoji
          "J": null, // znači da u ovom slučaju opcija ne postoji
        },
        answer_id: 303, // ako se prazan forma prvi put prikazuje customeru onda je answer_id null.
        answer: 'C', // odgovor moze biti "A","B","C","D", itd... zavisno koliko ima opcija
      },
      {
        question_id: 4,
        question_type: 'STARS_5',
        title: 'Pitanje STARS_5 1?',
        answer_id: 304, // ako se prazan forma prvi put prikazuje customeru onda je answer_id null.
        answer: 3, // odgovor moze biti 1,2,3,4,5 i to predstavlja rating
      },
      {
        question_id: 5,
        question_type: 'SCALE_5',
        // question_scale5_type: 'PROBABILITY', // NE TREBA DO DALJNJEG
        title: 'Pitanje SCALE_5 1?',
        question_option_titles: {
          "100": "Almost certain", // u tabeli questions ovo polja nazvati opt_scale100
          "75": "Highly likely", // u tabeli questions ovo polja nazvati opt_scale75
          "50": "Likely/probable", // u tabeli questions ovo polja nazvati opt_scale50
          "25": "Unlikely", // u tabeli questions ovo polja nazvati opt_scale25
          "0": "Almost certainly not", // u tabeli questions ovo polja nazvati opt_scale0
        },
        answer_id: 305, // ako se prazan forma prvi put prikazuje customeru onda je answer_id null.
        answer: 50, // odgovor moze biti 0,25,50,75,100 i to predstavlja procenat
      },
      {
        question_id: 6,
        question_type: 'CHECKLIST',
        title: 'Pitanje CHECKLIST 1?',
        // question_checklist: 'Prvi check;Drugi check;Treći check;Četvrti check;',
        question_checklist: ['Prvi check', 'Drugi check', 'Treći check', 'Četvrti check'],
        answer_id: 306, // ako se prazan forma prvi put prikazuje customeru onda je answer_id null.
        answer: [true, false, true, false], // answer je takodej array u kojemu se sam otrue računa kao true a sve ostalo tumači se kao false.
        answer_extra: 'Nisam izabrao ni jedno od navedenog zbog bla bla', // extra answer
      },
    ],
  },
  "meta": { // meta podaci od samog responsea i controllera, debug i sl.
    "thisis": 'survey-app surveyController',
    "readme": "Response od API /api/v1/survey/SURVEYKEY..."
  }
};
// const dummy_payload = null;



// 
const temp_2025_03_03_new_template_blueprint = {
  "survey_img_src": null,
  "title": "Quiz title",
  "survey_text": "Quiz description",
  "questions": [
    {
      "tempkey": 107,
      "question_type": "TEXT",
      "title": "Text pitanje",
      "required": true,
      "question_id": 107,
      "answer": null
    },
    {
      "tempkey": 108,
      "question_type": "YES_NO",
      "title": "Yesno pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Yesno extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_id": 108,
      "answer": null
    },
    {
      "tempkey": 109,
      "question_type": "STARS_5",
      "title": "Stars pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Stars extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_id": 109,
      "answer": null
    },
    {
      "tempkey": 110,
      "question_type": "SCALE_5",
      "title": "Scale pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Scale extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_option_titles": {
        "0": "Almost certainly not",
        "25": "Unlikely",
        "50": "Likely/probable",
        "75": "Highly likely",
        "100": "Almost certain"
      },
      "question_id": 110,
      "answer": null
    },
    {
      "tempkey": 111,
      "question_type": "ABC",
      "title": "Abc pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Abc extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_option_titles": {
        "A": "Alfa",
        "B": "Bravo",
        "C": "Charlie",
        "D": null,
        "E": null,
        "F": null,
        "G": null,
        "H": null,
        "I": null,
        "J": null
      },
      "question_id": 111,
      "answer": null
    },
    {
      "tempkey": 112,
      "question_type": "CHECKLIST",
      "title": "Checklist pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Checklist extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_checklist": [
        "Prvi check",
        "Drugi check"
      ],
      "question_id": 112,
      "answer": [
        false,
        false
      ]
    }
  ]
};

//
const temp_2025_03_03_new_template_preview_initial_snswers = [
  {
    "question_id": 107,
    "q": {
      "tempkey": 107,
      "question_type": "TEXT",
      "title": "Text pitanje",
      "required": true,
      "question_id": 107,
      "answer": null
    },
    "answer_main": null,
    "answer_extra": null
  },
  {
    "question_id": 108,
    "q": {
      "tempkey": 108,
      "question_type": "YES_NO",
      "title": "Yesno pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Yesno extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_id": 108,
      "answer": null
    },
    "answer_main": null,
    "answer_extra": null
  },
  {
    "question_id": 109,
    "q": {
      "tempkey": 109,
      "question_type": "STARS_5",
      "title": "Stars pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Stars extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_id": 109,
      "answer": null
    },
    "answer_main": null,
    "answer_extra": null
  },
  {
    "question_id": 110,
    "q": {
      "tempkey": 110,
      "question_type": "SCALE_5",
      "title": "Scale pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Scale extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_option_titles": {
        "0": "Almost certainly not",
        "25": "Unlikely",
        "50": "Likely/probable",
        "75": "Highly likely",
        "100": "Almost certain"
      },
      "question_id": 110,
      "answer": null
    },
    "answer_main": null,
    "answer_extra": null
  },
  {
    "question_id": 111,
    "q": {
      "tempkey": 111,
      "question_type": "ABC",
      "title": "Abc pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Abc extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_option_titles": {
        "A": "Alfa",
        "B": "Bravo",
        "C": "Charlie",
        "D": null,
        "E": null,
        "F": null,
        "G": null,
        "H": null,
        "I": null,
        "J": null
      },
      "question_id": 111,
      "answer": null
    },
    "answer_main": null,
    "answer_extra": null
  },
  {
    "question_id": 112,
    "q": {
      "tempkey": 112,
      "question_type": "CHECKLIST",
      "title": "Checklist pitanje",
      "required": true,
      "extra_answer_enabled": true,
      "extra_question_title": "Checklist extra",
      "extra_answer_required": true,
      "extra_answer_condition": null,
      "_extra_answer_condition_enabled": false,
      "question_checklist": [
        "Prvi check",
        "Drugi check"
      ],
      "question_id": 112,
      "answer": [
        false,
        false
      ]
    },
    "answer_main": [
      false,
      false
    ],
    "answer_extra": null
  }
];

//
const temp_2025_03_03_new_template_submit_response = {
  "message": "Survey template created successfully.",
  "survey": {
    "survey_template_id": 1,
    "title": "Quiz title",
    "text": "Quiz description",
    "img_url": null,
    "date_created_template": "2025-03-04T08:24:24.000Z",
    "service_type": "Prodaja",

    "is_review": true,
    "review_text": "Please review us on Google",
    "review_link": "https://google.com",

    "client": {
      "client_id": 1,
      "name": "firma",
      "email": "firma@firma.com",
      "phone": "321",
      "logo": null,
      "is_active": true
    },
    "questions": [
      {
        "question_id": 1,
        "question_type": "text",
        "title": "Text pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": false,
        "extra_answer_required": null,
        "extra_question_title": null,
        "extra_answer_condition": null
      },
      {
        "question_id": 2,
        "question_type": "yesno",
        "title": "Yesno pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Yesno extra",
        "extra_answer_condition": null
      },
      {
        "question_id": 3,
        "question_type": "stars",
        "title": "Stars pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Stars extra",
        "extra_answer_condition": null
      },
      {
        "question_id": 4,
        "question_type": "scale",
        "title": "Scale pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": "Almost certain",
        "opt_scale75": "Highly likely",
        "opt_scale50": "Likely/probable",
        "opt_scale25": "Unlikely",
        "opt_scale0": "Almost certainly not",
        "checklist": null,
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Scale extra",
        "extra_answer_condition": null
      },
      {
        "question_id": 5,
        "question_type": "abc",
        "title": "Abc pitanje",
        "required": true,
        "a": "Alfa",
        "b": "Bravo",
        "c": "Charlie",
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Abc extra",
        "extra_answer_condition": null
      },
      {
        "question_id": 6,
        "question_type": "checklist",
        "title": "Checklist pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": [
          "Prvi check",
          "Drugi check"
        ],
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Checklist extra",
        "extra_answer_condition": null
      }
    ]
  }
};

//
const temp_2025_03_03_new_instance_response = {
  "message": "Survey responses retrieved successfully.",
  "surveys": [
    {
      "survey_instance_id": "c0ce40c1-2c32-4224-9923-a60b2cf2e9f0",
      "date_filled": null,
      "status": "pending",
      "service_date": "2025-03-03T23:00:00.000Z",
      "date_due": "2025-06-03T22:00:00.000Z",
      "is_first_email_sent": false,
      "is_second_email_sent": false,
      "date_to_send_first_email": "2025-04-03T22:00:00.000Z",
      "date_to_send_second_email": "2025-05-03T22:00:00.000Z",
      "is_anonymous": false,
      "survey_template_id": 1,
      "title": "Quiz title",
      "text": "Quiz description",
      "img_url": null,
      "date_created_template": "2025-03-04T08:24:24.000Z",
      "service_type": "Prodaja",
      "client": {
        "client_id": 1,
        "name": "firma",
        "email": "firma@firma.com",
        "phone": "321",
        "logo": null,
        "is_active": true
      },
      "customer": {
        "customer_id": 1,
        "is_anonymous": false,
        "name": "ispitanik",
        // "surname": "ispitanikovic",
        "email": "ispitanik@ispitanik.com",
        "date_created": "2025-03-04T09:43:29.000Z"
      },
      "questions": [
        {
          "question_id": 1,
          "question_type": "text",
          "title": "Text pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": null,
          "extra_answer_enabled": false,
          "extra_answer_required": null,
          "extra_question_title": null,
          "extra_answer_condition": null,
          "answer_id": null,
          "answer": null,
          "extra_answer": null
        },
        {
          "question_id": 2,
          "question_type": "yesno",
          "title": "Yesno pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": null,
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Yesno extra",
          "extra_answer_condition": null,
          "answer_id": null,
          "answer": null,
          "extra_answer": null
        },
        {
          "question_id": 3,
          "question_type": "stars",
          "title": "Stars pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": null,
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Stars extra",
          "extra_answer_condition": null,
          "answer_id": null,
          "answer": null,
          "extra_answer": null
        },
        {
          "question_id": 4,
          "question_type": "scale",
          "title": "Scale pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": "Almost certain",
          "opt_scale75": "Highly likely",
          "opt_scale50": "Likely/probable",
          "opt_scale25": "Unlikely",
          "opt_scale0": "Almost certainly not",
          "checklist": null,
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Scale extra",
          "extra_answer_condition": null,
          "answer_id": null,
          "answer": null,
          "extra_answer": null
        },
        {
          "question_id": 5,
          "question_type": "abc",
          "title": "Abc pitanje",
          "required": true,
          "a": "Alfa",
          "b": "Bravo",
          "c": "Charlie",
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": null,
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Abc extra",
          "extra_answer_condition": null,
          "answer_id": null,
          "answer": null,
          "extra_answer": null
        },
        {
          "question_id": 6,
          "question_type": "checklist",
          "title": "Checklist pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": [
            "Prvi check",
            "Drugi check"
          ],
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Checklist extra",
          "extra_answer_condition": null,
          "answer_id": null,
          "answer": null,
          "extra_answer": null
        }
      ]
    }
  ]
};

//
const temp_2025_03_03_new_fill_response = {
  "message": "Survey responses submitted successfully.",
  "survey": {
    "survey_instance_id": "c0ce40c1-2c32-4224-9923-a60b2cf2e9f0",
    "date_filled": "2025-03-04T10:04:12.000Z",
    "status": "filled",
    "service_date": "2025-03-03T23:00:00.000Z",
    "date_due": "2025-06-03T22:00:00.000Z",
    "is_first_email_sent": false,
    "is_second_email_sent": false,
    "date_to_send_first_email": "2025-04-03T22:00:00.000Z",
    "date_to_send_second_email": "2025-05-03T22:00:00.000Z",
    "is_anonymous": true,
    "customer_id": 1,
    "survey_template_id": 1,
    "title": "Quiz title",
    "text": "Quiz description",
    "img_url": null,
    "date_created_template": "2025-03-04T08:24:24.000Z",
    "service_type": "Prodaja",
    "client": {
      "client_id": 1,
      "name": "firma",
      "email": "firma@firma.com",
      "phone": "321",
      "logo": null,
      "is_active": true
    },
    "questions": [
      {
        "question_id": 1,
        "question_type": "text",
        "title": "Text pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": false,
        "extra_answer_required": null,
        "extra_question_title": null,
        "extra_answer_condition": null,
        "answer_id": 1,
        "answer": "Something",
        "extra_answer": null
      },
      {
        "question_id": 2,
        "question_type": "yesno",
        "title": "Yesno pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Yesno extra",
        "extra_answer_condition": null,
        "answer_id": 2,
        "answer": false,
        "extra_answer": "Extra yesno"
      },
      {
        "question_id": 3,
        "question_type": "stars",
        "title": "Stars pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Stars extra",
        "extra_answer_condition": null,
        "answer_id": 3,
        "answer": 4,
        "extra_answer": "Extra yesno"
      },
      {
        "question_id": 4,
        "question_type": "scale",
        "title": "Scale pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": "Almost certain",
        "opt_scale75": "Highly likely",
        "opt_scale50": "Likely/probable",
        "opt_scale25": "Unlikely",
        "opt_scale0": "Almost certainly not",
        "checklist": null,
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Scale extra",
        "extra_answer_condition": null,
        "answer_id": 4,
        "answer": 25,
        "extra_answer": "Extra scale"
      },
      {
        "question_id": 5,
        "question_type": "abc",
        "title": "Abc pitanje",
        "required": true,
        "a": "Alfa",
        "b": "Bravo",
        "c": "Charlie",
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": null,
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Abc extra",
        "extra_answer_condition": null,
        "answer_id": 5,
        "answer": "b",
        "extra_answer": "Extra abc"
      },
      {
        "question_id": 6,
        "question_type": "checklist",
        "title": "Checklist pitanje",
        "required": true,
        "a": null,
        "b": null,
        "c": null,
        "d": null,
        "e": null,
        "f": null,
        "g": null,
        "h": null,
        "i": null,
        "j": null,
        "opt_scale100": null,
        "opt_scale75": null,
        "opt_scale50": null,
        "opt_scale25": null,
        "opt_scale0": null,
        "checklist": [
          "Prvi check",
          "Drugi check"
        ],
        "extra_answer_enabled": true,
        "extra_answer_required": true,
        "extra_question_title": "Checklist extra",
        "extra_answer_condition": null,
        "answer_id": 6,
        "answer": [
          false,
          true
        ],
        "extra_answer": "Extra checklist"
      }
    ]
  }
};

//
const temp_2025_03_03_new_instances_filled_response = {
  "message": "Survey responses retrieved successfully.",
  "surveys": [
    {
      "survey_instance_id": "c0ce40c1-2c32-4224-9923-a60b2cf2e9f0",
      "date_filled": "2025-03-04T10:04:12.000Z",
      "status": "filled",
      "service_date": "2025-03-03T23:00:00.000Z",
      "date_due": "2025-06-03T22:00:00.000Z",
      "is_first_email_sent": false,
      "is_second_email_sent": false,
      "date_to_send_first_email": "2025-04-03T22:00:00.000Z",
      "date_to_send_second_email": "2025-05-03T22:00:00.000Z",
      "is_anonymous": true,
      "survey_template_id": 1,
      "title": "Quiz title",
      "text": "Quiz description",
      "img_url": null,
      "date_created_template": "2025-03-04T08:24:24.000Z",
      "service_type": "Prodaja",
      "client": {
        "client_id": 1,
        "name": "firma",
        "email": "firma@firma.com",
        "phone": "321",
        "logo": null,
        "is_active": true
      },
      "customer": {
        "customer_id": 1,
        "is_anonymous": false,
        "name": "ispitanik",
        // "surname": "ispitanikovic",
        "email": "ispitanik@ispitanik.com",
        "date_created": "2025-03-04T09:43:29.000Z"
      },
      "questions": [
        {
          "question_id": 1,
          "question_type": "text",
          "title": "Text pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": null,
          "extra_answer_enabled": false,
          "extra_answer_required": null,
          "extra_question_title": null,
          "extra_answer_condition": null,
          "answer_id": 1,
          "answer": "Something",
          "extra_answer": null
        },
        {
          "question_id": 2,
          "question_type": "yesno",
          "title": "Yesno pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": null,
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Yesno extra",
          "extra_answer_condition": null,
          "answer_id": 2,
          "answer": true,
          "extra_answer": "Extra yesno"
        },
        {
          "question_id": 3,
          "question_type": "stars",
          "title": "Stars pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": null,
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Stars extra",
          "extra_answer_condition": null,
          "answer_id": 3,
          "answer": 4,
          "extra_answer": "Extra yesno"
        },
        {
          "question_id": 4,
          "question_type": "scale",
          "title": "Scale pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": "Almost certain",
          "opt_scale75": "Highly likely",
          "opt_scale50": "Likely/probable",
          "opt_scale25": "Unlikely",
          "opt_scale0": "Almost certainly not",
          "checklist": null,
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Scale extra",
          "extra_answer_condition": null,
          "answer_id": 4,
          "answer": 25,
          "extra_answer": "Extra scale"
        },
        {
          "question_id": 5,
          "question_type": "abc",
          "title": "Abc pitanje",
          "required": true,
          "a": "Alfa",
          "b": "Bravo",
          "c": "Charlie",
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": null,
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Abc extra",
          "extra_answer_condition": null,
          "answer_id": 5,
          "answer": "b",
          "extra_answer": "Extra abc"
        },
        {
          "question_id": 6,
          "question_type": "checklist",
          "title": "Checklist pitanje",
          "required": true,
          "a": null,
          "b": null,
          "c": null,
          "d": null,
          "e": null,
          "f": null,
          "g": null,
          "h": null,
          "i": null,
          "j": null,
          "opt_scale100": null,
          "opt_scale75": null,
          "opt_scale50": null,
          "opt_scale25": null,
          "opt_scale0": null,
          "checklist": [
            "Prvi check",
            "Drugi check"
          ],
          "extra_answer_enabled": true,
          "extra_answer_required": true,
          "extra_question_title": "Checklist extra",
          "extra_answer_condition": null,
          "answer_id": 6,
          "answer": [
            "false",
            "true"
          ],
          "extra_answer": "Extra checklist"
        }
      ]
    }
  ]
};


// ---

//
export const _zzsurvey_utils_demo_res_v2_make = () => {
  const temp = {
    ...temp_2025_03_03_new_template_submit_response.survey
  };
  temp.img_url = _zzsurvey_dummy_other.dummy_survey_logo_img_src;
  console.log(temp);
  return temp;
};

